import React from 'react';
import { Link as CustomLink } from 'gatsby';
import { useLocale } from '@hooks';

const Link: React.FC<any> = ({ to, language, ...others }) => {
    const { currentLanguage } = useLocale();

    return (
        <CustomLink
            {...others}
            to={`/${language ? language : currentLanguage}${to}`}
        />
    );
};

export default Link;
